export const LOGIN_REQ = "LOGIN_REQ";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT_PAGE = "LOGOUT_PAGE";
